import GoogleMaps from './google-maps.js'

export default {
  /** @param {Object} app */
  async install(app) {
    GoogleMaps.install(app);
  }
}
